define(["exports", "hyperhtml", "./utils"], function (_exports, _hyperhtml, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.idlStringToHtml = idlStringToHtml;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["<code>", "</code>"]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["<span>{{ ", " }}</span>"]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["<a\n    data-cite=\"WebIDL\"\n    data-xref-type=\"interface\"\n    >", "</a>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\"<a\n    data-cite=\"WebIDL\"\n    data-xref-type=\"exception\"\n    >", "</a>\""]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["\"<a\n    data-xref-type=\"enum-value\"\n    data-link-for=\"", "\"\n    data-xref-for=\"", "\"\n    data-lt=\"", "\"\n    >", "</a>\""]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["", "<a\n    data-xref-type=\"", "\"\n    data-link-for=\"", "\"\n    data-xref-for=\"", "\"\n    data-lt=\"", "\"\n    >", "</a>(", ")"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["", "<a\n      data-xref-type=\"attribute|dict-member\"\n      data-link-for=\"", "\"\n      data-xref-for=\"", "\"\n    >", "</a>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["", "[[<a\n    data-xref-type=\"attribute\"\n    data-link-for=", "\n    data-xref-for=", "\n    data-lt=\"", "\">", "</a>]]"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<a data-xref-type=\"_IDL_\">", "</a>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const idlPrimitiveRegex = /^[a-z]+(\s+[a-z]+)+$/; // {{unrestricted double}} {{ double }}

  const exceptionRegex = /\B"([^"]*)"\B/; // {{ "SomeException" }}

  const methodRegex = /(\w+)\((.*)\)$/;
  const slotRegex = /^\[\[(\w+)\]\]$/; // matches: `value` or `[[value]]`
  // NOTE: [[value]] is actually a slot, but database has this as type="attribute"

  const attributeRegex = /^((?:\[\[)?(?:\w+)(?:\]\])?)$/;
  const enumRegex = /^(\w+)\["([\w- ]*)"\]$/; // TODO: const splitRegex = /(?<=\]\]|\b)\./
  // https://github.com/w3c/respec/pull/1848/files#r225087385

  const methodSplitRegex = /\.?(\w+\(.*\)$)/;
  /**
   * @typedef {object} IdlBase
   * @property {"base"} type
   * @property {string} identifier
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlAttribute
   * @property {"attribute"} type
   * @property {string} identifier
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlInternalSlot
   * @property {"internal-slot"} type
   * @property {string} identifier
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlMethod
   * @property {"method"} type
   * @property {string} identifier
   * @property {string[]} args
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlEnum
   * @property {"enum"} type
   * @property {string} [identifier]
   * @property {string} enumValue
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlException
   * @property {"exception"} type
   * @property {string} identifier
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {object} IdlPrimitive
   * @property {"idl-primitive"} type
   * @property {string} identifier
   * @property {boolean} renderParent
   * @property {InlineIdl | null} [parent]
   *
   * @typedef {IdlBase | IdlAttribute | IdlInternalSlot | IdlMethod | IdlEnum | IdlException | IdlPrimitive} InlineIdl
   */

  /**
   * @param {string} str
   * @returns {InlineIdl[]}
   */

  function parseInlineIDL(str) {
    const [nonMethodPart, methodPart] = str.split(methodSplitRegex);
    const tokens = nonMethodPart.split(/[./]/).concat(methodPart).filter(s => s && s.trim()).map(s => s.trim());
    const renderParent = !str.includes("/");
    /** @type {InlineIdl[]} */

    const results = [];

    while (tokens.length) {
      const value = tokens.pop(); // Method

      if (methodRegex.test(value)) {
        const [, identifier, allArgs] = value.match(methodRegex);
        const args = allArgs.split(/,\s*/).filter(arg => arg);
        results.push({
          type: "method",
          identifier,
          args,
          renderParent
        });
        continue;
      } // Enum["enum value"]


      if (enumRegex.test(value)) {
        const [, identifier, enumValue] = value.match(enumRegex);
        results.push({
          type: "enum",
          identifier,
          enumValue,
          renderParent
        });
        continue;
      } // Exception - "NotAllowedError"
      // Or alternate enum syntax: {{ EnumContainer / "some enum value" }}


      if (exceptionRegex.test(value)) {
        const [, identifier] = value.match(exceptionRegex);

        if (renderParent) {
          results.push({
            type: "exception",
            identifier
          });
        } else {
          results.push({
            type: "enum",
            enumValue: identifier,
            renderParent
          });
        }

        continue;
      } // internal slot


      if (slotRegex.test(value)) {
        const [, identifier] = value.match(slotRegex);
        results.push({
          type: "internal-slot",
          identifier,
          renderParent
        });
        continue;
      } // attribute


      if (attributeRegex.test(value) && tokens.length) {
        const [, identifier] = value.match(attributeRegex);
        results.push({
          type: "attribute",
          identifier,
          renderParent
        });
        continue;
      }

      if (idlPrimitiveRegex.test(value)) {
        results.push({
          type: "idl-primitive",
          identifier: value,
          renderParent
        });
        continue;
      } // base, always final token


      if (attributeRegex.test(value) && tokens.length === 0) {
        results.push({
          type: "base",
          identifier: value,
          renderParent
        });
        continue;
      }

      throw new SyntaxError("IDL micro-syntax parsing error in `{{ ".concat(str, " }}`"));
    } // link the list


    results.forEach((item, i, list) => {
      item.parent = list[i + 1] || null;
    }); // return them in the order we found them...

    return results.reverse();
  }
  /**
   * @param {IdlBase} details
   */


  function renderBase(details) {
    // Check if base is a local variable in a section
    const {
      identifier,
      renderParent
    } = details;

    if (renderParent) {
      return (0, _hyperhtml.default)(_templateObject(), identifier);
    }
  }
  /**
   * Internal slot: .[[identifier]] or [[identifier]]
   * @param {IdlInternalSlot} details
   */


  function renderInternalSlot(details) {
    const {
      identifier,
      parent,
      renderParent
    } = details;
    const {
      identifier: linkFor
    } = parent || {};
    const lt = "[[".concat(identifier, "]]");
    const html = (0, _hyperhtml.default)(_templateObject2(), parent && renderParent ? "." : "", linkFor, linkFor, lt, identifier);
    return html;
  }
  /**
   * Attribute: .identifier
   * @param {IdlAttribute} details
   */


  function renderAttribute(details) {
    const {
      parent,
      identifier,
      renderParent
    } = details;
    const {
      identifier: linkFor
    } = parent || {};
    const html = (0, _hyperhtml.default)(_templateObject3(), renderParent ? "." : "", linkFor, linkFor, identifier);
    return html;
  }
  /**
   * Method: .identifier(arg1, arg2, ...), identifier(arg1, arg2, ...)
   * @param {IdlMethod} details
   */


  function renderMethod(details) {
    const {
      args,
      identifier,
      type,
      parent,
      renderParent
    } = details;
    const {
      identifier: linkFor
    } = parent || {};
    const argsText = args.map(arg => "<var>".concat(arg, "</var>")).join(", ");
    const searchText = "".concat(identifier, "(").concat(args.join(", "), ")");
    const html = (0, _hyperhtml.default)(_templateObject4(), parent && renderParent ? "." : "", type, linkFor, linkFor, searchText, identifier, [argsText]);
    return html;
  }
  /**
   * Enum:
   * Identifier["enum value"]
   * Identifer / "enum value"
   * @param {IdlEnum} details
   */


  function renderEnum(details) {
    const {
      identifier,
      enumValue,
      parent
    } = details;
    const forContext = parent ? parent.identifier : identifier;
    const html = (0, _hyperhtml.default)(_templateObject5(), forContext, forContext, !enumValue ? "the-empty-string" : null, enumValue);
    return html;
  }
  /**
   * Exception value: "NotAllowedError"
   * Only the WebIDL spec can define exceptions
   * @param {IdlException} details
   */


  function renderException(details) {
    const {
      identifier
    } = details;
    const html = (0, _hyperhtml.default)(_templateObject6(), identifier);
    return html;
  }
  /**
   * Interface types: {{ unrestricted double }} {{long long}}
   * Only the WebIDL spec defines these types.
   * @param {IdlPrimitive} details
   */


  function renderIdlPrimitiveType(details) {
    const {
      identifier
    } = details;
    const html = (0, _hyperhtml.default)(_templateObject7(), identifier);
    return html;
  }
  /**
   * Generates HTML by parsing an IDL string
   * @param {String} str IDL string
   * @return {Node} html output
   */


  function idlStringToHtml(str) {
    let results;

    try {
      results = parseInlineIDL(str);
    } catch (error) {
      const el = (0, _hyperhtml.default)(_templateObject8(), str);
      (0, _utils.showInlineError)(el, error.message, "Error: Invalid inline IDL string");
      return el;
    }

    const render = (0, _hyperhtml.default)(document.createDocumentFragment());
    const output = [];

    for (const details of results) {
      switch (details.type) {
        case "base":
          {
            const base = renderBase(details);
            if (base) output.push(base);
            break;
          }

        case "attribute":
          output.push(renderAttribute(details));
          break;

        case "internal-slot":
          output.push(renderInternalSlot(details));
          break;

        case "method":
          output.push(renderMethod(details));
          break;

        case "enum":
          output.push(renderEnum(details));
          break;

        case "exception":
          output.push(renderException(details));
          break;

        case "idl-primitive":
          output.push(renderIdlPrimitiveType(details));
          break;

        default:
          throw new Error("Unknown type.");
      }
    }

    const result = render(_templateObject9(), output);
    return result;
  }
});
//# sourceMappingURL=inline-idl-parser.js.map